import Vue from "vue";
import VueI18n from "vue-i18n";

import ru from "~/locales/ru";
import en from "~/locales/en";

Vue.use(VueI18n);

// Язык сборки. На проде ru, на стендах en — задаётся VUE_APP_DEFAULT_LOCALE
// в .env.<mode>, чтобы прод не поехал от того, что появился второй язык.
const DEFAULT_LOCALE = "ru";

export const SUPPORTED_LOCALES = ["ru", "en"];
export const LOCALE_STORAGE_KEY = "panel_locale";

function initialLocale() {
  // Выбор пользователя в этом браузере важнее сборочного языка.
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (stored && SUPPORTED_LOCALES.includes(stored)) return stored;
  } catch (e) {
    // приватный режим или заблокированные site data — молча идём дальше
  }
  const fromEnv = process.env.VUE_APP_DEFAULT_LOCALE;
  return SUPPORTED_LOCALES.includes(fromEnv) ? fromEnv : DEFAULT_LOCALE;
}

const i18n = new VueI18n({
  locale: initialLocale(),
  // Если ключ забыли перевести, показываем русский текст, а не сам ключ.
  fallbackLocale: DEFAULT_LOCALE,
  // Непереведённые ключи — предупреждением в консоль только при разработке.
  silentFallbackWarn: process.env.NODE_ENV === "production",
  silentTranslationWarn: process.env.NODE_ENV === "production",
  messages: { ru, en },
});

export function setLocale(locale) {
  if (!SUPPORTED_LOCALES.includes(locale)) return;
  i18n.locale = locale;
  try {
    localStorage.setItem(LOCALE_STORAGE_KEY, locale);
  } catch (e) {
    // не критично: язык продержится до перезагрузки страницы
  }
  document.documentElement.setAttribute("lang", locale);
}

document.documentElement.setAttribute("lang", i18n.locale);

export default i18n;
